<template>
    <div class="text-message">
        <BaseMessageBubble :color="options.from === userID ? 'var(--order-soft, #E1F7EC)' : '#FFFFFF'">
            <span v-if="options.type === 'TIMTextElem'" class="tim-text">{{ options.payload.text }}</span>
            <div v-else-if="JSON.parse(options.payload.data).customType == 'video_call'">
                <div class="row center">
                    <span> {{ content }}</span>
                    <img class="videoIcon" src="~@/assets/image/video.png" />
                </div>
            </div>
        </BaseMessageBubble>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseMessageBubble from './BaseMessageBubble.vue'
export default {
    name: 'txtMessage',
    components: {
        BaseMessageBubble,
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters(['userID']),
        content() {
            const { type, time } = JSON.parse(this.options.payload.data)
            switch (type) {
                case 1:
                    return `视频通话结束 ${time}`
                case 2:
                    return '取消视频'
                case 3:
                    return '拒绝视频'
                case 4:
                    return '视频未响应'
            }
        },
    },
    props: {
        options: {
            type: Object,
            default: () => {},
        },
    },
}
</script>

<style>
.text-message {
}

.tim-text {
    word-break: break-word;
    white-space: pre-wrap;
}
.videoIcon {
    width: 20px;
    height: 15px;
    margin-left: 10px;
}
</style>
